import { CREATE_HOLIDAY, RETRIEVE_HOLIDAYS, UPDATE_HOLIDAY, DELETE_HOLIDAY } from '../actions/types';

const initialState = [];

function holidayReducer(holidays = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case RETRIEVE_HOLIDAYS:
            return payload;

        // The following cases are good for optimistic updates,
        // but our current pattern relies on re-fetching the list after CUD operations.
        // So, RETRIEVE_HOLIDAYS is the most critical one.

        case CREATE_HOLIDAY:
            return [...holidays, payload];

        case UPDATE_HOLIDAY:
            return holidays.map((holiday) => {
                if (holiday.holiday_id === payload.holiday_id) {
                    return {
                        ...holiday,
                        ...payload,
                    };
                } else {
                    return holiday;
                }
            });

        case DELETE_HOLIDAY:
            // This assumes a soft delete where we might want to update the status locally
            // A simpler approach is just to re-fetch the list.
            return holidays.filter(({ holiday_id }) => holiday_id !== payload.id);

        default:
            return holidays;
    }
}

export default holidayReducer;
